<template>
  <transition-group name="toast-fade" tag="div" class="ui-snackbar-container">
    <woot-snackbar
      v-for="snackMessage in snackMessages"
      :key="snackMessage.key"
      :message="snackMessage.message"
      :action="snackMessage.action"
      :type="snackMessage.type"
    />
  </transition-group>
</template>

<script>
import WootSnackbar from './Snackbar';

export default {
  components: {
    WootSnackbar,
  },
  props: {
    duration: {
      type: Number,
      default: 2500,
    },
  },

  data() {
    return {
      snackMessages: [],
    };
  },

  mounted() {
    bus.$on('newToastMessage', this.onNewToastMessage);
  },
  beforeDestroy() {
    bus.$off('newToastMessage', this.onNewToastMessage);
  },
  methods: {
    // Muestra un toast; duration opcional (ms) para avisos que conviene dejar más tiempo. Al
    // expirar se quita ese toast por su clave, no el más viejo, porque las duraciones pueden variar.
    onNewToastMessage(message, action, type = 'info', duration) {
      const key = `${Date.now()}-${Math.random()}`;
      this.snackMessages.push({ key, message, action, type });
      window.setTimeout(() => {
        this.snackMessages = this.snackMessages.filter(
          snack => snack.key !== key
        );
      }, duration || this.duration);
    },
  },
};
</script>
